import { AxiosResponse } from "axios";

import API from "../api";
import { Secret } from "../models/secret";

const ROUTE_NAME = "management/secrets";

export const ManageSecretService = {
  async getSecrets(): Promise<AxiosResponse<Secret>> {
    return await API.get(`/${ROUTE_NAME}`);
  },
};
